import * as core from '../../../../../../../core'

import { query } from './edit-subawards.query'

export const RESOURCE = {
  payload: {
    alias: 'sr.subawards.widgets.edit-subawards',
    description: 'Edit Subaward',
    name: 'Edit Subaward',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
